import styled from "styled-components";
import { colors } from "../../../styles/colors";

interface StyledProps {
  $isOpen?: boolean;
}

export const SelectContainer = styled.div<StyledProps>`
  position: relative;
  width: 70px;
  direction: rtl;

  .select-button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 12px 4px 7px;
    border-radius: 50px;
    background-color: ${colors.lightBlueGrayBackground};
    color: ${colors.darkBlue};
    font-size: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
    border: none;

    .dropdown-arrow {
      width: 7px;
      height: 7px;
      transform: ${(props) =>
        props.$isOpen ? "rotate(180deg)" : "rotate(0deg)"};
      transition: transform 0.2s ease;
    }
  }
`;

export const SelectDropdown = styled.div<StyledProps>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightBlueGray};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 4px;
  direction: rtl;

  &::-webkit-scrollbar {
    width: 6px;

    &-track {
      background: ${colors.gray};
      border-radius: 3px;
    }

    &-thumb {
      background: ${colors.blueGray};
      border-radius: 3px;
    }
  }
`;

export const SelectOption = styled.div<StyledProps>`
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-size: 10px;
  color: ${colors.darkBlue};
  text-align: right;

  &:hover {
    background-color: ${colors.lightBlueGrayBackground};
  }

  &.selected {
    background-color: ${colors.blue};
    color: ${colors.white};
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;
